import { render, staticRenderFns } from "./Benevolence.vue?vue&type=template&id=bda21e50&scoped=true&"
import script from "./Benevolence.vue?vue&type=script&lang=js&"
export * from "./Benevolence.vue?vue&type=script&lang=js&"
import style0 from "./Benevolence.vue?vue&type=style&index=0&id=bda21e50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda21e50",
  null
  
)

export default component.exports